import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import get from 'lodash/get';
import omit from 'lodash/omit';

import SlideshowVideoItem from './slideshow_item.video.jsx';
import SlideshowImageItem from './slideshow_item.image.jsx';

import SiteViewerVersionComponentSelector
  from 'zoomforth_codesbane_viewer/component_lib/site_viewer_version_component_selector_container.jsx';

class SlideshowItem_ViewerVersion1 extends Component {

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    if (this.props.isSelected) {
      this.props.onSlideDisplay();
    }
  }

  render() {

    const {
      isPlayable,
      asset,
      contentItem,
      children,
      currentSlideIdx,
      videoishPlayerProps,
      onSetVideoPlaying,
      ...props
    } = this.props;

    // react-slick Slider expects its children to consume arbitrary props.
    // Since a div node would not expect our custom props we can extract the
    // slickProps object by assuming the props leftover are slick-defined.
    const slickProps = omit(props, [
      'displayImage',
      'isSelected',
      'onSlideDisplay'
    ]);

    return (
      <div
        key={contentItem.eid || contentItem.uuid}
        className={classNames('galleria-image', {
          [`content-uuid-${contentItem.uuid}`]: contentItem.uuid
        })}
        { ...slickProps }
      >
        {
          isPlayable ?
            <SlideshowVideoItem
              asset={asset}
              contentItem={contentItem}
              currentSlideIdx={currentSlideIdx}
              onSetVideoPlaying={onSetVideoPlaying}
              {...videoishPlayerProps}
            />
          :
            <SlideshowImageItem
              asset={asset}
              contentItem={contentItem}
              alt={contentItem.alt_text || get(asset, 'alt_text')}
            />
        }

        {children}
      </div>
    );
  }

}

const SlideshowItem_ViewerVersion2 = ({
  idx,
  asset,
  children,
  isPlayable,
  contentItem,
  currentSlideIdx,
  onSetVideoPlaying,
  videoishPlayerProps
})=> (
  <Fragment>
    {
      isPlayable ?
        <SlideshowVideoItem
          idx={idx}
          asset={asset}
          contentItem={contentItem}
          currentSlideIdx={currentSlideIdx}
          onSetVideoPlaying={onSetVideoPlaying}
          {...videoishPlayerProps}
        />
      :
        <SlideshowImageItem
          idx={idx}
          alt={contentItem.alt_text || get(asset, 'alt_text')}
          asset={asset}
          contentItem={contentItem}
        />
    }

    {children}
  </Fragment>
);

const SlideshowItem = (props)=> (
  <SiteViewerVersionComponentSelector>
    <SlideshowItem_ViewerVersion1 forSiteViewerVersion={1} { ...props } />
    <SlideshowItem_ViewerVersion2 forSiteViewerVersion={2} { ...props } />
  </SiteViewerVersionComponentSelector>
);

SlideshowItem.propTypes = {
  contentItem: PropTypes.object.isRequired,
  displayImage: PropTypes.string,
  isPlayable: PropTypes.bool.isRequired,
  videoishPlayerProps: PropTypes.object.isRequired,
  onSetVideoPlaying: PropTypes.func,
  onSlideDisplay: PropTypes.func
};

export default SlideshowItem;
